import getBearToken from "./token";

const headers = () => {
    return {
        'Authorization': `${getBearToken()}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
}

export default headers;